import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { LevelText } from '@dyl/systems/LevelsManager';
import DataGridDyl from '@dyl/components/DataGridDyl';
import quickDateFormat from '@dyl/utils/quickDateFormat';
import Skills from '@dyl/constants/Skills';

/**
 * @typedef Props
 * @property {string} componentIds
 * @property {(componentIds: string[]) => void} onConfirmChanges
 * @property {import('./logic').ComponentOption[]} componentOptions
 */

/** @type {import('@mui/x-data-grid').GridColDef[]} */
const Columns = [
    { headerName: 'Component ID', field: 'test_name', flex: 3 },
    { headerName: 'Skill', field: 'skill_id', flex: 2, valueFormatter({ value }) {
        return Skills.find(s => s.value === value)?.label;
    }
    },
    { headerName: 'Level', field: 'level_id', flex: 2, renderCell({ value }) {
        return <LevelText levelId={value} />;
    }
    },
    { headerName: 'Last modified', field: 'updated_at', flex: 2, valueFormatter({ value }) {
        return quickDateFormat(value);
    }
    }
];

const getRowId = component => component.test_id;

/**
 * @param {Props & import('@mui/material').DialogProps} props
 */
export default function ComponentPicker(props) {
    const {
        componentIds,
        onConfirmChanges: propsOnConfirm,
        open,
        onClose,
        componentOptions,
        ...other
    } = props;

    const [internalList, setInternalList] = useState([]);

    useEffect(() => {
        if (open) {
            setInternalList([...componentIds]);
        }
    }, [open]);

    const onConfirm = () => {
        propsOnConfirm([...internalList]);
        onClose();
    };

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth='lg'
            {...other}
        >
            <DialogTitle>
                Please select one component for each skill
            </DialogTitle>

            <DialogContent>
                <DataGridDyl
                    columns={Columns}
                    rows={componentOptions}
                    selectionModel={internalList}
                    onSelectionModelChange={s => setInternalList(s)}
                    selectionType='ordered-checkboxes'
                    getRowId={getRowId}
                    localeText={lang}
                    searchField='test_name'
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>
                    Cancel
                </Button>

                <Button
                    data-testid='file-picker-add-item'
                    color='primary'
                    onClick={onConfirm}
                    variant='contained'
                    id='AddComponentToTestButton'
                >
                    Add to Test
                </Button>
            </DialogActions>
        </Dialog>
    );
}

/** @type {import('@mui/x-data-grid').GridLocaleText} */
const lang = {
    footerRowSelected: count => `${count} components selected`,
};